import React from "react";
import { Sparkles } from "lucide-react";
import useSiteSettings from "@/hooks/useSiteSettings";

/**
 * Pricing transparency — Track 1 priority #3.
 * Sets honest expectations: no commission on trades, SaaS-only when paid plans launch.
 * Admin-editable via site_settings.pricing_tagline.
 */
export default function PricingTransparency() {
  const s = useSiteSettings() || {};
  const tagline = s.pricing_tagline || "Free during pilot · No commission on trades · SaaS-only when paid plans launch";

  return (
    <div className="pricing-strip" data-testid="landing-pricing-strip">
      <div style={{ display: "flex", gap: 10, alignItems: "center", flex: "0 0 auto" }}>
        <Sparkles size={16} color="var(--amber-400)" />
        <span className="font-mono" style={{ fontSize: 11, letterSpacing: ".15em", color: "var(--amber-400)" }}>
          PRICING · TRANSPARENT
        </span>
      </div>
      <div style={{ flex: "1 1 auto", minWidth: 0, fontSize: 14, color: "var(--ink-dim)", lineHeight: 1.5 }}>
        {tagline}
      </div>
    </div>
  );
}
